var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 93,
    viewBox: "0 0 112 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.742 0.921021L90.112 6.80417L95.6238 12.4005L77.6149 30.6855L70.758 24.157L32.4546 63.0478L27.9058 58.8595L0 87.1931L4.81201 92.0789L28.1337 68.3964L32.6825 72.5879L70.9121 33.7754L77.7658 40.3039L100.436 17.2863L105.948 22.8826L111.742 0.921021Z",
    fill: "#41D17E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6441 82.8073C75.0083 82.8073 90.7061 67.1095 90.7061 47.7453C90.7061 28.381 75.0083 12.6832 55.6441 12.6832C36.2798 12.6832 20.582 28.381 20.582 47.7453C20.582 67.1095 36.2798 82.8073 55.6441 82.8073Z",
    fill: "url(#paint0_linear_219_5411)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_5411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 69,
    height: 69
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6482 81.9403C74.5337 81.9403 89.8434 66.6306 89.8434 47.7452C89.8434 28.8597 74.5337 13.55 55.6482 13.55C36.7628 13.55 21.4531 28.8597 21.4531 47.7452C21.4531 66.6306 36.7628 81.9403 55.6482 81.9403Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_5411)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M93.3711 48.2826V47.2088L17.9338 47.2088V48.2826L93.3711 48.2826Z",
    fill: "url(#paint1_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M56.1852 10.0269H55.1113V85.4642H56.1852V10.0269Z",
    fill: "url(#paint2_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M82.6968 21.4519L81.9375 20.6926L28.5953 74.0349L29.3546 74.7942L82.6968 21.4519Z",
    fill: "url(#paint3_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M29.3511 20.6965L28.5918 21.4558L81.934 74.7981L82.6934 74.0387L29.3511 20.6965Z",
    fill: "url(#paint4_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M93.2128 44.4383L93.1035 43.37L18.0577 51.0458L18.167 52.1141L93.2128 44.4383Z",
    fill: "url(#paint5_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M52.3319 10.1625L51.2637 10.272L58.9526 85.3164L60.0208 85.207L52.3319 10.1625Z",
    fill: "url(#paint6_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M79.8894 18.8307L79.0566 18.1527L31.4291 76.654L32.2618 77.332L79.8894 18.8307Z",
    fill: "url(#paint7_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M26.7346 23.5174L26.0566 24.3502L84.558 71.9777L85.2359 71.145L26.7346 23.5174Z",
    fill: "url(#paint8_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M92.6229 40.2511L92.3945 39.2018L18.6832 55.2465L18.9116 56.2958L92.6229 40.2511Z",
    fill: "url(#paint9_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M48.1547 10.771L47.1055 10.9994L63.1502 84.7107L64.1995 84.4823L48.1547 10.771Z",
    fill: "url(#paint10_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.4991 16.3002L75.5957 15.7198L34.8193 79.1869L35.7227 79.7673L76.4991 16.3002Z",
    fill: "url(#paint11_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M24.2035 26.9069L23.623 27.8103L87.0901 68.5867L87.6706 67.6833L24.2035 26.9069Z",
    fill: "url(#paint12_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M91.6956 36.6492L91.3652 35.6275L19.5876 58.8387L19.918 59.8605L91.6956 36.6492Z",
    fill: "url(#paint13_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M44.5413 11.6931L43.5195 12.0235L66.7308 83.8011L67.7525 83.4707L44.5413 11.6931Z",
    fill: "url(#paint14_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M73.2999 14.4039L72.3438 13.9151L38.0021 81.0824L38.9582 81.5712L73.2999 14.4039Z",
    fill: "url(#paint15_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M22.3013 30.0978L21.8125 31.0539L88.9798 65.3955L89.4686 64.4394L22.3013 30.0978Z",
    fill: "url(#paint16_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M90.3696 32.9941L89.9355 32.0118L20.9347 62.5024L21.3687 63.4846L90.3696 32.9941Z",
    fill: "url(#paint17_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M40.8944 13.034L39.9121 13.4678L70.3906 82.474L71.3729 82.0401L40.8944 13.034Z",
    fill: "url(#paint18_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M69.7612 12.7588L68.7598 12.3712L41.5289 82.7223L42.5303 83.1099L69.7612 12.7588Z",
    fill: "url(#paint19_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M20.6552 33.6245L20.2676 34.6259L90.6186 61.8568L91.0063 60.8554L20.6552 33.6245Z",
    fill: "url(#paint20_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M88.556 29.299L88.0176 28.3699L22.7463 66.1911L23.2846 67.1202L88.556 29.299Z",
    fill: "url(#paint21_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M37.1987 14.8473L36.2695 15.3857L74.0908 80.657L75.0199 80.1186L37.1987 14.8473Z",
    fill: "url(#paint22_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M65.8717 11.4363L64.834 11.16L45.4238 84.0575L46.4615 84.3338L65.8717 11.4363Z",
    fill: "url(#paint23_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M19.3388 37.5276L19.0625 38.5653L91.9599 57.9754L92.2362 56.9378L19.3388 37.5276Z",
    fill: "url(#paint24_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.0312 25.4025L85.3828 24.5465L25.247 70.0929L25.8953 70.9489L86.0312 25.4025Z",
    fill: "url(#paint25_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.2994 17.3601L32.4434 18.0085L77.9898 78.1443L78.8458 77.496L33.2994 17.3601Z",
    fill: "url(#paint26_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M61.3294 10.457L60.2656 10.3101L49.9493 85.0387L51.0131 85.1856L61.3294 10.457Z",
    fill: "url(#paint27_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M18.3578 42.0609L18.2109 43.1246L92.9395 53.4409L93.0864 52.3772L18.3578 42.0609Z",
    fill: "url(#paint28_linear_219_5411)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6441 82.8073C75.0083 82.8073 90.7061 67.1095 90.7061 47.7453C90.7061 28.381 75.0083 12.6832 55.6441 12.6832C36.2798 12.6832 20.582 28.381 20.582 47.7453C20.582 67.1095 36.2798 82.8073 55.6441 82.8073Z",
    stroke: "url(#paint29_linear_219_5411)",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.646 77.8466C72.2704 77.8466 85.7471 64.3699 85.7471 47.7455C85.7471 31.1211 72.2704 17.6444 55.646 17.6444C39.0216 17.6444 25.5449 31.1211 25.5449 47.7455C25.5449 64.3699 39.0216 77.8466 55.646 77.8466Z",
    fill: "url(#paint30_linear_219_5411)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.646 77.8466C72.2704 77.8466 85.7471 64.3699 85.7471 47.7455C85.7471 31.1211 72.2704 17.6444 55.646 17.6444C39.0216 17.6444 25.5449 31.1211 25.5449 47.7455C25.5449 64.3699 39.0216 77.8466 55.646 77.8466Z",
    fill: "url(#paint31_linear_219_5411)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.6422 73.1706C69.6843 73.1706 81.0676 61.7873 81.0676 47.7452C81.0676 33.7031 69.6843 22.3198 55.6422 22.3198C41.6001 22.3198 30.2168 33.7031 30.2168 47.7452C30.2168 61.7873 41.6001 73.1706 55.6422 73.1706Z",
    fill: "url(#paint32_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.6422 73.1706C69.6843 73.1706 81.0676 61.7873 81.0676 47.7452C81.0676 33.7031 69.6843 22.3198 55.6422 22.3198C41.6001 22.3198 30.2168 33.7031 30.2168 47.7452C30.2168 61.7873 41.6001 73.1706 55.6422 73.1706Z",
    stroke: "url(#paint33_linear_219_5411)",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.6452 71.6326C68.8378 71.6326 79.5326 60.9378 79.5326 47.7452C79.5326 34.5526 68.8378 23.8578 55.6452 23.8578C42.4525 23.8578 31.7578 34.5526 31.7578 47.7452C31.7578 60.9378 42.4525 71.6326 55.6452 71.6326Z",
    stroke: "url(#paint34_linear_219_5411)",
    strokeWidth: 0.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2266 31.6207L60.3053 77.4882C62.274 77.1806 64.1812 76.6884 66.0045 76.0173L33.8508 26.9841C32.4973 28.4047 31.2836 29.954 30.2266 31.6207Z",
    fill: "url(#paint35_linear_219_5411)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5449 47.7451C25.5449 61.4925 34.7621 73.0922 47.3573 76.6884L25.8022 43.8132C25.6344 45.0996 25.5449 46.4084 25.5449 47.7395V47.7451Z",
    fill: "url(#paint36_linear_219_5411)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4329 52.1131L63.5143 18.6898C61.6294 18.1809 59.6719 17.8509 57.6641 17.7167L84.0011 57.8794C84.6611 56.0338 85.1421 54.1042 85.4329 52.1131Z",
    fill: "url(#paint37_linear_219_5411)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.82 20.5074L75.5107 70.3627C76.07 69.8705 76.6125 69.3559 77.1382 68.819L44.8782 19.6293C44.1791 19.8977 43.4912 20.1886 42.8145 20.5074H42.82Z",
    fill: "url(#paint38_linear_219_5411)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9126 71.3253C42.2848 71.3253 28.8115 57.8464 28.8115 41.2242C28.8115 37.6447 29.4714 34.2275 30.618 31.0395C27.4188 35.8214 25.5508 41.5654 25.5508 47.7511C25.5508 64.3789 39.0297 77.8522 55.6519 77.8522C68.7002 77.8522 79.7742 69.5356 83.9521 57.9303C78.5549 66.0064 69.3601 71.3253 58.9182 71.3253H58.9126Z",
    fill: "url(#paint39_linear_219_5411)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.646 77.8466C72.2704 77.8466 85.7471 64.3699 85.7471 47.7455C85.7471 31.1211 72.2704 17.6444 55.646 17.6444C39.0216 17.6444 25.5449 31.1211 25.5449 47.7455C25.5449 64.3699 39.0216 77.8466 55.646 77.8466Z",
    stroke: "url(#paint40_linear_219_5411)",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.31,
    d: "M55.6428 81.2749C74.1607 81.2749 89.1724 66.2632 89.1724 47.7454C89.1724 29.2275 74.1607 14.2158 55.6428 14.2158C37.125 14.2158 22.1133 29.2275 22.1133 47.7454C22.1133 66.2632 37.125 81.2749 55.6428 81.2749Z",
    stroke: "url(#paint41_linear_219_5411)",
    strokeWidth: 1.02,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.6682 19.1151L56.1212 20.0324L57.1391 20.1834L56.4009 20.8993L56.5743 21.9116L55.6682 21.4306L54.7566 21.9116L54.9299 20.8993L54.1973 20.1834L55.2096 20.0324L55.6682 19.1151Z",
    fill: "url(#paint42_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M55.6682 73.5066L56.1212 74.4294L57.1391 74.5748L56.4009 75.2907L56.5743 76.3031L55.6682 75.8277L54.7566 76.3031L54.9299 75.2907L54.1973 74.5748L55.2096 74.4294L55.6682 73.5066Z",
    fill: "url(#paint43_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M27.0742 47.7062L27.9915 47.2531L28.1425 46.2352L28.8584 46.9735L29.8707 46.8001L29.3897 47.7062L29.8707 48.6178L28.8584 48.4444L28.1425 49.1771L27.9915 48.1648L27.0742 47.7062Z",
    fill: "url(#paint44_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M81.4668 47.7062L82.3896 47.2531L82.535 46.2352L83.2509 46.9735L84.2633 46.8001L83.7879 47.7062L84.2633 48.6178L83.2509 48.4444L82.535 49.1771L82.3896 48.1648L81.4668 47.7062Z",
    fill: "url(#paint45_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.4415 27.4878L36.4147 27.8178L37.2368 27.2026L37.2256 28.2317L38.0646 28.8245L37.0802 29.1265L36.7782 30.1109L36.1853 29.272L35.1562 29.2831L35.7715 28.461L35.4415 27.4878Z",
    fill: "url(#paint46_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M73.9024 65.9503L74.8756 66.2803L75.6978 65.6651L75.6866 66.6942L76.5255 67.287L75.5412 67.5891L75.2391 68.5734L74.6463 67.7345L73.6172 67.7457L74.2324 66.9235L73.9024 65.9503Z",
    fill: "url(#paint47_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.4415 67.9299L35.7715 66.9567L35.1562 66.1346L36.1853 66.1458L36.7782 65.3068L37.0802 66.2856L38.0646 66.5932L37.2256 67.186L37.2368 68.2151L36.4147 67.5999L35.4415 67.9299Z",
    fill: "url(#paint48_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M73.9024 29.4674L74.2324 28.4942L73.6172 27.672L74.6463 27.6832L75.2391 26.8443L75.5412 27.8287L76.5255 28.1307L75.6866 28.7235L75.6978 29.7526L74.8756 29.1374L73.9024 29.4674Z",
    fill: "url(#paint49_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M48.1195 20.1334L48.7962 20.8997L49.8197 20.7766L49.2996 21.6603L49.7302 22.5887L48.7291 22.3706L47.9797 23.0697L47.879 22.0462L46.9785 21.554L47.9237 21.1401L48.1195 20.1334Z",
    fill: "url(#paint50_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M62.4811 72.5952L63.1634 73.3614L64.1813 73.2383L63.6612 74.122L64.0974 75.056L63.0963 74.8323L62.3412 75.5314L62.2406 74.5135L61.3457 74.0158L62.2853 73.6019L62.4811 72.5952Z",
    fill: "url(#paint51_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.0859 55.2627L28.8522 54.5804L28.7235 53.5625L29.6128 54.0826L30.5412 53.6464L30.3231 54.6531L31.0222 55.4026L29.9987 55.5032L29.5009 56.4037L29.0927 55.4585L28.0859 55.2627Z",
    fill: "url(#paint52_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.543 40.9001L81.3092 40.2177L81.1862 39.1998L82.0698 39.72L82.9983 39.2837L82.7801 40.2849L83.4793 41.0399L82.4557 41.1406L81.958 42.0354L81.5497 41.0958L80.543 40.9001Z",
    fill: "url(#paint53_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.8203 33.5505L31.8438 33.612L32.4758 32.801L32.7387 33.7966L33.7007 34.1433L32.8338 34.697L32.8002 35.7261L32.006 35.0718L31.0217 35.357L31.3964 34.4006L30.8203 33.5505Z",
    fill: "url(#paint54_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M78.0762 60.4916L79.0997 60.5532L79.7317 59.7422L79.9945 60.7321L80.9565 61.0845L80.0896 61.6382L80.0561 62.6673L79.2619 62.0129L78.2775 62.2982L78.6522 61.3418L78.0762 60.4916Z",
    fill: "url(#paint55_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.5014 72.5555L41.5629 71.532L40.752 70.9L41.7419 70.6371L42.0943 69.6751L42.648 70.542L43.677 70.5756L43.0227 71.3698L43.3079 72.3541L42.3515 71.9794L41.5014 72.5555Z",
    fill: "url(#paint56_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M68.4372 25.301L68.4987 24.2775L67.6934 23.6455L68.6833 23.3826L69.0357 22.4207L69.5894 23.2876L70.6129 23.3211L69.9641 24.1153L70.2437 25.0997L69.2929 24.7249L68.4372 25.301Z",
    fill: "url(#paint57_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M41.9881 22.6168L42.827 23.2041L43.789 22.8517L43.487 23.8305L44.1246 24.6359L43.0955 24.6526L42.525 25.5084L42.195 24.5352L41.2051 24.2555L42.0272 23.6403L41.9881 22.6168Z",
    fill: "url(#paint58_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M67.9627 70.4083L68.8016 71.0011L69.7636 70.6432L69.4616 71.6275L70.0936 72.4329L69.0701 72.4441L68.4996 73.2998L68.1696 72.3266L67.1797 72.047L68.0018 71.4318L67.9627 70.4083Z",
    fill: "url(#paint59_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.5137 61.3922L31.1065 60.5533L30.7486 59.5913L31.7329 59.8933L32.5383 59.2613L32.5495 60.2848L33.4052 60.8553L32.432 61.1853L32.1524 62.1752L31.5372 61.353L30.5137 61.3922Z",
    fill: "url(#paint60_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M78.3027 35.4239L78.8956 34.585L78.5432 33.6174L79.522 33.925L80.3274 33.2874L80.3442 34.3165L81.1943 34.887L80.2211 35.217L79.9471 36.2013L79.3318 35.3792L78.3027 35.4239Z",
    fill: "url(#paint61_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M28.2188 39.6303L29.2311 39.4514L29.6617 38.5229L30.1427 39.429L31.1606 39.552L30.4447 40.2847L30.6461 41.2914L29.7232 40.8384L28.8284 41.3418L28.9738 40.3239L28.2188 39.6303Z",
    fill: "url(#paint62_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M80.3809 55.0606L81.3932 54.8817L81.8238 53.9532L82.3048 54.8593L83.3227 54.9823L82.6068 55.715L82.8082 56.7217L81.8854 56.2687L80.9905 56.7721L81.1359 55.7542L80.3809 55.0606Z",
    fill: "url(#paint63_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.5273 75.1618L47.3539 74.1495L46.4199 73.7188L47.326 73.2378L47.449 72.2199L48.1817 72.9358L49.194 72.7345L48.7354 73.6573L49.2388 74.5522L48.2208 74.4067L47.5273 75.1618Z",
    fill: "url(#paint64_linear_219_5411)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M62.959 23.0021L62.7856 21.9897L61.8516 21.5591L62.7576 21.0781L62.8807 20.0602L63.6189 20.7761L64.6257 20.5747L64.167 21.4976L64.6704 22.3924L63.6525 22.247L62.959 23.0021Z",
    fill: "url(#paint65_linear_219_5411)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1848 54.2392C67.1848 56.3504 66.4776 58.1196 65.0633 59.5469C63.649 60.9444 61.6533 61.8959 59.0761 62.4014V68.735H53.5132V62.8028C49.616 62.6839 46.3316 61.8662 43.6602 60.3497L45.2159 56.1125C46.7559 56.8856 48.2645 57.4654 49.7417 57.852C51.2503 58.2088 52.8374 58.3872 54.5032 58.3872C56.326 58.3872 57.8504 58.0601 59.0761 57.4059C60.3018 56.722 60.9147 55.7854 60.9147 54.596C60.9147 53.4066 60.349 52.4997 59.2175 51.8752C58.1175 51.2211 56.4361 50.552 54.1732 49.8681C52.1617 49.2437 50.5274 48.649 49.2702 48.084C48.0131 47.5191 46.9445 46.7311 46.0645 45.7201C45.1845 44.6794 44.7445 43.371 44.7445 41.7951C44.7445 39.565 45.5145 37.7511 47.0545 36.3536C48.6259 34.956 50.7788 34.0491 53.5132 33.6328V27.5669H59.0761V33.5436C61.8104 33.8707 64.2304 34.6438 66.3362 35.863L64.7805 40.011C62.109 38.5837 59.4847 37.8701 56.9075 37.8701C55.1789 37.8701 53.7646 38.1823 52.6646 38.8067C51.5646 39.4312 51.0145 40.3083 51.0145 41.4383C51.0145 42.1816 51.2974 42.8209 51.8631 43.3562C52.4289 43.8617 53.136 44.2928 53.9846 44.6496C54.8332 45.0065 56.0118 45.4227 57.5204 45.8985C59.5632 46.5527 61.229 47.1771 62.5176 47.7718C63.8062 48.3368 64.9062 49.1545 65.8176 50.2249C66.7291 51.2657 67.1848 52.6037 67.1848 54.2392Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_5411",
    x1: 69.453,
    y1: 11.4024,
    x2: 46.2983,
    y2: 72.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DD88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_5411",
    x1: 55.6524,
    y1: 47.2088,
    x2: 55.6524,
    y2: 48.2882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_219_5411",
    x1: 55.1113,
    y1: 47.7456,
    x2: 56.1852,
    y2: 47.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_219_5411",
    x1: 55.2624,
    y1: 47.3677,
    x2: 56.0257,
    y2: 48.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_219_5411",
    x1: 55.2708,
    y1: 48.1269,
    x2: 56.0301,
    y2: 47.3676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_219_5411",
    x1: 55.5628,
    y1: 47.1985,
    x2: 55.6726,
    y2: 48.2723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_219_5411",
    x1: 55.1026,
    y1: 47.7948,
    x2: 56.1764,
    y2: 47.6848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_219_5411",
    x1: 55.2263,
    y1: 47.3971,
    x2: 56.0634,
    y2: 48.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_219_5411",
    x1: 55.2986,
    y1: 48.1569,
    x2: 55.9801,
    y2: 47.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_219_5411",
    x1: 55.5213,
    y1: 47.2222,
    x2: 55.7509,
    y2: 48.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_219_5411",
    x1: 55.1302,
    y1: 47.866,
    x2: 56.1795,
    y2: 47.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_219_5411",
    x1: 55.2105,
    y1: 47.4486,
    x2: 56.1187,
    y2: 48.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_219_5411",
    x1: 55.3502,
    y1: 48.1878,
    x2: 55.9307,
    y2: 47.2843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_219_5411",
    x1: 55.4676,
    y1: 47.2242,
    x2: 55.7998,
    y2: 48.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_219_5411",
    x1: 55.1215,
    y1: 47.9194,
    x2: 56.1486,
    y2: 47.5872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_219_5411",
    x1: 55.1655,
    y1: 47.4887,
    x2: 56.1266,
    y2: 47.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_219_5411",
    x1: 55.3811,
    y1: 48.2296,
    x2: 55.8725,
    y2: 47.2685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_219_5411",
    x1: 55.4425,
    y1: 47.26,
    x2: 55.8788,
    y2: 48.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_219_5411",
    x1: 55.1514,
    y1: 47.9709,
    x2: 56.1388,
    y2: 47.5348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_219_5411",
    x1: 55.1339,
    y1: 47.5427,
    x2: 56.1405,
    y2: 47.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_219_5411",
    x1: 55.4443,
    y1: 48.2538,
    x2: 55.8339,
    y2: 47.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_219_5411",
    x1: 55.3694,
    y1: 47.2813,
    x2: 55.9106,
    y2: 48.2152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_219_5411",
    x1: 55.185,
    y1: 48.0185,
    x2: 56.1141,
    y2: 47.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_219_5411",
    x1: 55.1329,
    y1: 47.6156,
    x2: 56.176,
    y2: 47.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_219_5411",
    x1: 55.5101,
    y1: 48.2527,
    x2: 55.7864,
    y2: 47.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_219_5411",
    x1: 55.3138,
    y1: 47.3275,
    x2: 55.9655,
    y2: 48.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_219_5411",
    x1: 55.2267,
    y1: 48.0898,
    x2: 56.0827,
    y2: 47.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_219_5411",
    x1: 55.1067,
    y1: 47.68,
    x2: 56.176,
    y2: 47.8276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_219_5411",
    x1: 55.5815,
    y1: 48.278,
    x2: 55.7284,
    y2: 47.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2882A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_219_5411",
    x1: 20.2576,
    y1: 47.7453,
    x2: 91.0361,
    y2: 47.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C28830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_219_5411",
    x1: 25.5449,
    y1: 47.7455,
    x2: 85.7527,
    y2: 47.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_219_5411",
    x1: 25.5449,
    y1: 47.7455,
    x2: 85.7527,
    y2: 47.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_219_5411",
    x1: 30.2224,
    y1: 47.7452,
    x2: 81.0676,
    y2: 47.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB67",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB67",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_219_5411",
    x1: 29.9651,
    y1: -28.3689,
    x2: 81.3249,
    y2: -28.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB67",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB67",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_219_5411",
    x1: 31.5005,
    y1: -28.3689,
    x2: 79.7898,
    y2: -28.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_219_5411",
    x1: 25.5453,
    y1: 52.2418,
    x2: 85.7531,
    y2: 52.2418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD973",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFD45F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_219_5411",
    x1: 25.5449,
    y1: 60.2564,
    x2: 85.7527,
    y2: 60.2564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD973",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFD45F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_219_5411",
    x1: 25.5439,
    y1: 37.7953,
    x2: 85.7517,
    y2: 37.7953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD973",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFD45F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_219_5411",
    x1: 25.5435,
    y1: 44.9932,
    x2: 85.7457,
    y2: 44.9932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD973",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFD45F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_219_5411",
    x1: 53.6328,
    y1: 52.9358,
    x2: 44.8967,
    y2: 75.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD973",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFD45F",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD257"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_219_5411",
    x1: 25.2149,
    y1: 47.7455,
    x2: 86.0771,
    y2: 47.7455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAB328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C28830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_219_5411",
    x1: 21.828,
    y1: 47.7454,
    x2: 89.4632,
    y2: 47.7454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DD88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_219_5411",
    x1: 56.5239,
    y1: 21.9451,
    x2: 54.9859,
    y2: 19.5514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_219_5411",
    x1: 56.5239,
    y1: 76.3366,
    x2: 54.9859,
    y2: 73.9428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_219_5411",
    x1: 29.9042,
    y1: 46.8505,
    x2: 27.5105,
    y2: 48.3885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_219_5411",
    x1: 84.3024,
    y1: 46.8505,
    x2: 81.9086,
    y2: 48.3885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_219_5411",
    x1: 38.0523,
    y1: 28.8783,
    x2: 35.276,
    y2: 28.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_219_5411",
    x1: 76.515,
    y1: 67.3426,
    x2: 73.7348,
    y2: 66.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_219_5411",
    x1: 36.8371,
    y1: 65.3165,
    x2: 36.2321,
    y2: 68.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_219_5411",
    x1: 75.2959,
    y1: 26.8561,
    x2: 74.6948,
    y2: 29.6324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_219_5411",
    x1: 49.6915,
    y1: 22.6403,
    x2: 47.5706,
    y2: 20.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_219_5411",
    x1: 64.0535,
    y1: 75.1067,
    x2: 61.9325,
    y2: 73.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_219_5411",
    x1: 30.5873,
    y1: 53.6921,
    x2: 28.69,
    y2: 55.8062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_219_5411",
    x1: 83.049,
    y1: 39.3291,
    x2: 81.1463,
    y2: 41.4446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_219_5411",
    x1: 33.704,
    y1: 34.2011,
    x2: 30.8599,
    y2: 34.3564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_219_5411",
    x1: 80.9607,
    y1: 61.1443,
    x2: 78.1194,
    y2: 61.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_219_5411",
    x1: 42.1531,
    y1: 69.671,
    x2: 42.3036,
    y2: 72.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_219_5411",
    x1: 69.0889,
    y1: 22.4178,
    x2: 69.247,
    y2: 25.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_219_5411",
    x1: 44.0915,
    y1: 24.6946,
    x2: 41.5971,
    y2: 23.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_219_5411",
    x1: 70.0598,
    y1: 72.4804,
    x2: 67.5681,
    y2: 71.1164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_219_5411",
    x1: 32.593,
    y1: 59.2896,
    x2: 31.2268,
    y2: 61.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_219_5411",
    x1: 80.3814,
    y1: 33.3193,
    x2: 79.0152,
    y2: 35.8186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_219_5411",
    x1: 31.173,
    y1: 39.6056,
    x2: 28.4467,
    y2: 40.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_219_5411",
    x1: 83.3392,
    y1: 55.031,
    x2: 80.6059,
    y2: 55.8321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_219_5411",
    x1: 47.5011,
    y1: 72.2018,
    x2: 48.3022,
    y2: 74.9351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_219_5411",
    x1: 62.9316,
    y1: 20.0449,
    x2: 63.7343,
    y2: 22.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F8D675",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F6DB82",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5DD88",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundSign);
export default __webpack_public_path__ + "static/media/fund_sign.d72744a7b63d225c5a7efb9aadc1df7d.svg";
export { ForwardRef as ReactComponent };